// ImageNode — niestandardowy node Lexical wyświetlający obrazki w trybie Rich (WYSIWYG)
// Konwertuje markdown ![alt](url) na widoczny <img> i z powrotem
import { DecoratorNode } from "lexical"

// parametry dołączane do URL resolwującego filename → obrazek
// ustawiane przez controller (attachable_type, attachable_id)
let _resolveParams = ""
export function setImageResolveParams(params) { _resolveParams = params }

export class ImageNode extends DecoratorNode {
  __src
  __alt

  static getType() {
    return "image"
  }

  static clone(node) {
    return new ImageNode(node.__src, node.__alt, node.__key)
  }

  constructor(src, alt, key) {
    super(key)
    this.__src = src
    this.__alt = alt || ""
  }

  getSrc() {
    return this.__src
  }

  getAlt() {
    return this.__alt
  }

  isInline() {
    return true
  }

  createDOM() {
    const span = document.createElement("span")
    span.style.display = "inline-block"
    span.style.maxWidth = "100%"
    const img = document.createElement("img")
    const isUrl = this.__src.startsWith("/") || this.__src.startsWith("http") || this.__src.startsWith("data:")
    img.src = isUrl ? this.__src : `/utils/attachments/image?${_resolveParams}filename=${encodeURIComponent(this.__src)}`
    img.alt = this.__alt
    img.style.maxWidth = "100%"
    img.style.display = "block"
    img.style.borderRadius = "4px"
    span.appendChild(img)
    return span
  }

  updateDOM() {
    return false
  }

  decorate() {
    return null
  }

  exportDOM() {
    const img = document.createElement("img")
    img.src = this.__src
    img.alt = this.__alt
    return { element: img }
  }

  static importDOM() {
    return {
      img: () => ({
        conversion: (element) => {
          const src = element.getAttribute("src")
          if (!src) return null
          const alt = element.getAttribute("alt") || ""
          return { node: $createImageNode(src, alt) }
        },
        priority: 0,
      }),
    }
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "image",
      src: this.__src,
      alt: this.__alt,
      version: 1,
    }
  }

  static importJSON(json) {
    return $createImageNode(json.src, json.alt)
  }
}

export function $createImageNode(src, alt) {
  return new ImageNode(src, alt)
}

export function $isImageNode(node) {
  return node instanceof ImageNode
}

// Markdown transformer: ![alt](url) <-> ImageNode
// WAŻNE: musi być przed LINK transformer (który matchuje [text](url))
// aby ![alt](url) nie został błędnie zinterpretowany jako link
export const IMAGE_TRANSFORMER = {
  dependencies: [ImageNode],
  export: (node) => {
    if (!$isImageNode(node)) return null
    return `![${node.getAlt()}](${node.getSrc()})`
  },
  importRegExp: /!\[([^\]]*)\]\(([^)]+)\)/,
  regExp: /!\[([^\]]*)\]\(([^)]+)\)$/,
  replace: (textNode, match) => {
    const [, alt, src] = match
    const imageNode = $createImageNode(src, alt)
    textNode.replace(imageNode)
  },
  trigger: ")",
  type: "text-match",
}
